// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dots__wrapper[data-v-3b0c5327]{position:relative;display:block}.dots__wrapper .dots__visible[data-v-3b0c5327]{overflow:hidden;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit}.dots__wrapper .dots__actual-content[data-v-3b0c5327],.dots__wrapper .dots__calculate[data-v-3b0c5327]{display:block;visibility:hidden;position:absolute;width:100%;top:0;left:0}", ""]);
// Exports
module.exports = exports;
